import { translateUi } from "@/shared/lib/ui-translate";

export type HeaderLayout = "top" | "bottom" | "left" | "right";

export const HEADER_LAYOUT_VALUES: HeaderLayout[] = [
  "top",
  "bottom",
  "left",
  "right",
];

export const HEADER_LAYOUT_LABELS: Record<HeaderLayout, string> = {
  get top() { return translateUi("litHeaderLayout.sverhu"); },
  get bottom() { return translateUi("litHeaderLayout.snizu"); },
  get left() { return translateUi("litHeaderLayout.sleva"); },
  get right() { return translateUi("litHeaderLayout.sprava"); },
};

export function isHeaderLayout(
  v: string | null | undefined,
): v is HeaderLayout {
  return HEADER_LAYOUT_VALUES.includes(v as HeaderLayout);
}

export function isVerticalHeader(layout: HeaderLayout): boolean {
  return layout === "left" || layout === "right";
}

/** pl-3/pr-3 (12px) + w-16 rail (64px) — отступ основного контента и сдвиг FAB */
export const HEADER_VERTICAL_RAIL_OFFSET_PX = 76;
